export const parseTableDate = (value: any): Date | null => {
  if (value === undefined || value === null || value === "") return null;
  const parsed = value instanceof Date ? value : new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatTableDate = (value: any): string => {
  const d = parseTableDate(value);
  if (!d) return "-";
  return `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;
};

export const formatTableDateTime = (value: any): string => {
  const d = parseTableDate(value);
  if (!d) return "-";
  const hours24 = d.getHours();
  const hours12 = hours24 % 12 || 12;
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const period = hours24 >= 12 ? "PM" : "AM";
  return `${formatTableDate(d)} ${hours12}:${minutes} ${period}`;
};
